// extracted by mini-css-extract-plugin
module.exports = {"container":"ShortText_container__1zBKs","input_disabled":"ShortText_input_disabled__wFQK1"};